import type { ForecastWeek } from '../../lib/api/forecast'

function fmt(n: number): string {
  return new Intl.NumberFormat('uk-UA', { maximumFractionDigits: 0 }).format(n)
}

type Props = {
  week: ForecastWeek
  onOpen: () => void
}

export function WeekRow({ week, onOpen }: Props) {
  const gap = week.flags.belowThreshold

  return (
    <tr
      style={{
        background: gap ? 'var(--danger-bg, rgba(248,113,113,0.06))' : undefined,
        cursor: 'pointer',
      }}
      onClick={onOpen}
    >
      <td
        style={{
          padding: '8px 12px',
          fontFamily: 'var(--font-mono)',
          color: 'var(--fg-2)',
          fontSize: 12,
          whiteSpace: 'nowrap',
        }}
      >
        {week.weekId}
      </td>
      <td style={{ padding: '8px 12px', fontSize: 12, color: 'var(--fg-3)', whiteSpace: 'nowrap' }}>
        {week.weekStart} → {week.weekEnd}
      </td>
      <td style={{ padding: '8px 12px', textAlign: 'right', fontSize: 13 }}>
        {fmt(week.opening)} UAH
      </td>
      <td style={{ padding: '8px 12px', textAlign: 'right', fontSize: 13, color: 'var(--success-fg, #22c55e)' }}>
        +{fmt(week.income)} UAH
      </td>
      <td style={{ padding: '8px 12px', textAlign: 'right', fontSize: 13, color: 'var(--danger-fg, #ef4444)' }}>
        −{fmt(Math.abs(week.expense))} UAH
      </td>
      <td
        style={{
          padding: '8px 12px',
          textAlign: 'right',
          fontSize: 13,
          fontWeight: 600,
          color: gap ? 'var(--danger-fg, #ef4444)' : 'var(--fg-1)',
        }}
      >
        {gap && <span style={{ marginRight: 4 }}>🚨</span>}
        {fmt(week.close)} UAH
      </td>
      <td style={{ padding: '8px 4px', textAlign: 'center', color: 'var(--fg-4)' }}>
        <button
          type="button"
          onClick={(e) => { e.stopPropagation(); onOpen() }}
          style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '2px 6px', color: 'var(--fg-3)' }}
          aria-label="Деталі"
        >
          ▾
        </button>
      </td>
    </tr>
  )
}
